import styled from 'styled-components';

import { greyCard } from '../../utils/style';

export default styled.div`
    ${(props) => greyCard(props)};
`;